import React, { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Menu, MenuItem } from '@mui/material'

function Select({
  options,
  selected,
  setSelected,
  placeholder = 'Select',
  className,
}: {
  options: { title: string; value: string }[]
  selected?: string | undefined
  setSelected: (value: string) => void
  placeholder?: string
  className?: string
}) {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    selected || undefined
  )
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <div onClick={handleClick} className={`${className} select`}>
        <span>
          {options.filter((item) => {
            return item.value === (selectedValue || selected)
          })[0]?.title || placeholder}
        </span>
        <ExpandMoreIcon />
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          marginTop: '5px',
          '.MuiMenu-list': { background: '#1B1B24' },
        }}
      >
        {options.map((item) => {
          return (
            <MenuItem
              key={item.value}
              onClick={() => {
                setSelectedValue(item.value)
                setSelected(item.value)
                handleClose()
              }}
            >
              <div className={'selectMenuItem'}>{item.title}</div>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default Select
